module.exports = __webpack_public_path__ + "static/img/sh_logo.e5dd919.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sh_logo.png
// module id = RkE9
// module chunks = 174